import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';
import { Text } from '../Text/Text.js';

const StyledText = styled(props => /*#__PURE__*/React__default.createElement(Text, _extends({
  as: "p"
}, props))).withConfig({
  componentId: "sg1390__sc-1yh7zjs-0"
})(["margin-bottom:", ";text-align:", ";"], props => !props.noMargin && tokens.space.lg, props => props.align);
const Paragraph = _ref => {
  let {
    align,
    children,
    className,
    id,
    noMargin,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledText, _extends({
    align: align,
    className: className,
    id: id,
    noMargin: noMargin
  }, rest), children);
};
Paragraph.displayName = 'Paragraph';
Paragraph.propTypes = {
  align: PropTypes.oneOf(['center']),
  /**
   * Text content of the component.
   */
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  /**
   * Disable default bottom margin.
   */
  noMargin: PropTypes.bool
};

export { Paragraph };
